import React, { Component } from 'react';
import { Modal, Button, Table, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';
import format from '../../shared/format';

class VersionRecord extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    show = (record = {}) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const {record: { evaluateCode }} = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryEvaluateRecordVersionList,
            data: { evaluateCode, limit: 9999 },
            dataType: 'json',
            doneResult: res => {
                this.setState({
                    data: res.datas,
                    loading: false,
                })
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '提交时间',
        dataIndex: 'submitTime',
        key: 'submitTime',
        width: 160,
    }, {
        title: '提交人',
        dataIndex: 'userCompellation',
        key: 'userCompellation',
        width: 100,
    }, {
        title: '访视评估提交前总价（不含税金额）',
        dataIndex: 'beforeSubmitAmount',
        key: 'beforeSubmitAmount',
        width: 120,
        render: text => (text || text == 0) ? format('money', text) : ''
    }, {
        title: '访视评估提交后总价（不含税金额）',
        dataIndex: 'afterSubmitAmount',
        key: 'afterSubmitAmount',
        width: 120,
        render: text => (text || text == 0) ? format('money', text) : ''
    }, {
        title: '一口价（建议评估提交前总价（不含税金额）',
        dataIndex: 'beforeSubmitFteAmount',
        key: 'beforeSubmitFteAmount',
        width: 120,
        render: text => (text || text == 0) ? format('money', text) : ''
    }, {
        title: '一口价（建议评估提交后总价（不含税金额）',
        dataIndex: 'afterSubmitFteAmount',
        key: 'afterSubmitFteAmount',
        width: 120,
        render: text => (text || text == 0) ? format('money', text) : ''
    }, {
        title: '版本号',
        dataIndex: 'versionNum',
        key: 'versionNum',
        width: 80,
    }, {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        width: 100,
        render: (text, record) => {
            const { quotationType } = record;
            return <div>
                <a onClick={() => this.visitQuote(record)}>访视评估</a>
                {
                (quotationType == 'VISIT_FTE_QUOTATION' || quotationType == 'FTE_QUOTATION') && <span>
                        <span className="ant-divider" />
                        <a onClick={() => this.FTEQuote(record)}>一口价（建议评估）</a>
                    </span>
                }
            </div>
        }
    }]

    visitQuote = (record) => {
        const { evaluateRecordId, evaluateCode } = record;
        const url = API_URL.evaluate.exportEvaluateRecordVisit;
        ExportUtil.export({ evaluateRecordId, evaluateSerialNumber: evaluateCode }, null, url);
        message.success(`开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出`);
    }

    FTEQuote = (record) => {
        const { evaluateRecordId, evaluateCode } = record;
        const url = API_URL.evaluate.exportEvaluateRecordFte;
        ExportUtil.export({ evaluateRecordId, evaluateSerialNumber: evaluateCode }, null, url);
        message.success(`开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出`);
    }

    render() {
        const { visible, loading, data, record } = this.state;
        const { evaluateCode } = record;
        return (
            <Modal
                title="评估版本记录"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        临床评估单号：{evaluateCode}
                    </div>
                    <div>
                        <Table
                            dataSource={data}
                            loading={loading}
                            columns={this.getColumns()}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default VersionRecord;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/VersionRecord.js